import { render } from "./SlabSelection.vue?vue&type=template&id=1a422b7e&scoped=true&ts=true"
import script from "./SlabSelection.vue?vue&type=script&lang=ts"
export * from "./SlabSelection.vue?vue&type=script&lang=ts"

import "./SlabSelection.vue?vue&type=style&index=0&id=1a422b7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a422b7e"]])

export default __exports__